import { render, staticRenderFns } from "./field.vue?vue&type=template&id=67cf188b&scoped=true"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"
import style0 from "./field.vue?vue&type=style&index=0&id=67cf188b&prod&lang=less&scoped=true"
import style1 from "./field.vue?vue&type=style&index=1&id=67cf188b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf188b",
  null
  
)

export default component.exports